import { Maximize2, Minimize2 } from "lucide-react";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface BookingFormMaximiseButtonProps {
  isMaximised: boolean;
  onToggle: () => void;
}

export function BookingFormMaximiseButton({ isMaximised, onToggle }: Readonly<BookingFormMaximiseButtonProps>) {
  const { t } = useTranslation();
  const label = isMaximised ? t("booking_form_restore") : t("booking_form_maximise");

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape" && isMaximised) {
        onToggle();
      }
    },
    [isMaximised, onToggle],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  return (
    <button
      type="button"
      className="booking-form-maximise-button"
      onClick={onToggle}
      aria-label={label}
      aria-pressed={isMaximised}
      title={label}
    >
      {isMaximised ? <Minimize2 aria-hidden="true" /> : <Maximize2 aria-hidden="true" />}
    </button>
  );
}
